import { useAuthStore } from '~/store/auth';
import { RouteName } from '~/types/enums/routes.enum';

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuthStore();

  if (!authStore.isCustomer) {
    return navigateTo(RouteName.DASHBOARD_USAGE);
  }
});
